import AsyncStorage from "@react-native-async-storage/async-storage";
import { actions as authActions } from "@reducers/authReducer";
import { actions as configActions } from "@reducers/configReducer";
import { all, call, put, takeLatest } from "redux-saga/effects";

import { getAppBootParams } from "@services/api";
import * as Sentry from "@sentry/react-native";
import {
  AUTH_ACTIONS,
  SET_LOGIN_RELATED_PARAMS,
} from "../reducers/actionTypes";

function* setNewUser() {
  yield all({
    newlyCreatedUser: AsyncStorage.setItem("newlyCreatedUser", "true"),
    navigateWhatsappScreenForNewUser: AsyncStorage.setItem(
      "navigateWhatsappScreenForNewUser",
      "true",
    ),
    showWelcomeTLtoTlToNew: AsyncStorage.setItem(
      "showWelcomeTLtoTlToNew",
      "true",
    ),
    signupSessionVideo: AsyncStorage.setItem("signupSessionVideo", "true"),
    startSession: AsyncStorage.setItem("startSession", "true"),
    signup_add_req: AsyncStorage.setItem("signup_add_req", "true"),
  });
  yield put(
    authActions.setNewUser({
      newlyCreatedUser: true,
      navigateWhatsappScreenForNewUser: true,
      showWelcomeTLtoTlToNew: true,
      signupSessionVideo: true,
      startSession: true,
      signup_add_req: true,
    }),
  );
}

function* removeNewUser() {
  yield all({
    newlyCreatedUser: AsyncStorage.removeItem("newlyCreatedUser"),
    isUserLoggedInFirst: AsyncStorage.removeItem("isUserLoggedInFirst"),
  });
  yield put(
    authActions.removeNewUser({
      newlyCreatedUser: null,
      isUserLoggedInFirst: null,
    }),
  );
}

// TODO ADD ANOTHER SAGA TO UPDATE newlyCreatedUser, isUserLoggedInFirst IN THE REDUX STORE

function* signoutUser() {
  const { token, isUserLoggedIn } = yield all({
    token: AsyncStorage.removeItem("user_token"),
    isUserLoggedIn: AsyncStorage.removeItem("isUserLoggedIn"),
  });
  yield put(
    authActions.signOut({
      token: null,
      isUserLoggedIn: null,
    }),
  );
  yield put({ type: "RESET_REDUX" });
}

function* restoreUserToken(action) {
  yield put(configActions.syncUser(false));
}

function* signInEffect({ payload: { verifyOtpResponse, userToken } }) {
  const { teamLeader } = verifyOtpResponse || {};

  const meParams = {
    userToken,
    discardedAt: teamLeader.discarded_at,
    rejectedAt: teamLeader.rejected_at,
    leaderState: teamLeader.leader_state,
    userName: teamLeader.name,
    alreadyCx: teamLeader.already_a_cx,
    alreadyCxWoOrder: teamLeader.already_a_cx_wo_order,
  };

  yield all([
    call(AsyncStorage.setItem, "user_token", userToken),
    call(AsyncStorage.setItem, "showCLToCLWelcome", "true"),
  ]);
  try {
    const { data: bootParams } = yield call(getAppBootParams);
    // meResponse is absent from /leader/setup-4's response when the backend
    // doesn't yet recognize the just-issued session (req.teamLeader has no
    // id) — a brief race right after login. Falling back to {} here avoids
    // a synchronous throw that used to abort this saga before the dispatches
    // below ever ran, permanently stranding the caller mid-login.
    const { meResponse = {} } = bootParams || {};
    const setupParams = {
      userPincode: meResponse.pincode,
      deviceGeog: meResponse.device_location_geog,
      isServiceable: meResponse.is_serviceable,
      lat: meResponse.lat,
      lng: meResponse.lng,
    };
    yield put(
      authActions.setLoginParams({
        meParams,
        setupParams,
      }),
    );
    yield put(
      configActions.syncUser({
        userToken,
        bootParams,
      }),
    );
  } catch (e) {
    Sentry.captureException(e);
  }
}

export default function* root() {
  yield all([
    takeLatest(AUTH_ACTIONS.SIGN_OUT_USER, signoutUser),
    takeLatest(AUTH_ACTIONS.SET_NEW_USER_REQUEST, setNewUser),
    takeLatest(AUTH_ACTIONS.REMOVE_NEW_USER_REQUEST, removeNewUser),
    takeLatest(AUTH_ACTIONS.RESTORE_USER_TOKEN, restoreUserToken),
    takeLatest(AUTH_ACTIONS.SIGN_IN, signInEffect),
  ]);
}
